import React from "react";
import { Card, CardBody } from "reactstrap";

const IconCard = ({className="mb-4", icon, title, value, id, L, onClick }) => {
  const color = ["act", "pub", "cal"].indexOf(id) > -1 && value === 0 ? "error-color" : ""
  const isClickable = typeof onClick === "function"
  const onKeyDown = (e) => {
    if (!isClickable) return
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault()
      onClick()
    }
  }
  return (
    <div className={`icon-row-item ${className}`}>
      <Card
        onClick={onClick}
        onKeyDown={onKeyDown}
        role={isClickable ? "button" : undefined}
        tabIndex={isClickable ? 0 : undefined}
        className={isClickable ? "cursor-pointer" : ""}
      >
        <CardBody className="text-center">
          <i className={`${icon} ${color?? ""}`} />
          <p className="card-text font-weight-semibold mb-0">
            {L[title]}
          </p>
          <p className={`lead text-center ${color?? ""}`}>{value}</p>
        </CardBody>
      </Card>
    </div>
  );
};

export default IconCard;
